
import useGetQueryPagination from "./helper/ueGetPagination";
import useAddMutation from "./helper/useAddMutation"
import useDeleteMutation from "./helper/useDeleteMutation"
import useGetOneQuery from "./helper/useGetOneQuery";

const API = {
  ADD: `notification`,
  GET_ALL: `notification`,
  DELETE: `notification`,

};
const KEY = "notification"


export const useGetNotification = (params?:any) => useGetQueryPagination(KEY, API.GET_ALL,params);
export const useGetOnenotification = (params?:any) => useGetOneQuery(KEY, API.GET_ALL,params);

export const useAddNotification = () => useAddMutation(KEY, API.ADD);

export const useDeleteNotification = () =>useDeleteMutation(KEY, API.DELETE);


